export enum LogLevel {
    all,
    debug,
    info,
    warning,
    error,
    none
}
